<script>

    export let title;
    export let value;
    export let name;
    export let checked = false;

</script>

<label {title}>
    <input type="checkbox" {value} {name} bind:checked on:change />
    <div class="box"></div>
    {#if $$slots.default}
        <p><slot /></p>
    {/if}
</label>

<style>

    label {
        cursor: pointer;
        display: flex;
        -webkit-user-select: none;
        user-select: none;
        position: relative;
    }

    input {
        display: block;
        width: 100%;
        height: 100%;
        opacity: 0;
        position: absolute;
    }

    .box {
		border: 1.5px solid currentColor;
		border-radius: 2em;
		width: 1em;
		height: 1em;
        cursor: pointer;
	}
    
    p {
        padding-left: 0.2em;
    }

    input:checked + div {
        background-color: var(--text-color);
    }

</style>